import { forwardRef } from 'react';

import { IconChevronDown } from 'ui-icons';

import { ActionIconProps } from '../../../../../../Buttons/ActionIcon/ActionIcon';
import { Button, ButtonProps } from '../../../../../../Buttons/ButtonMantine';
import { ThemeIcon } from '../../../../../../DataDisplay/ThemeIcon';
import { ActionMenuContainerProps, ActionMenuDefaultTarget } from '../../actions.types';
import { useActionMenuContext } from '../../context';
import { ActionIconTarget } from './ActionIconTarget';

const ActionsMenuTargetInner = <
  TDefaultTarget extends ActionMenuDefaultTarget = 'button',
  TProps = TDefaultTarget extends 'button' ? ButtonProps : ActionIconProps,
>(
  {
    Target,
    defaultTarget,
    defaultTargetProps,
    ...props
  }: ActionMenuContainerProps<TDefaultTarget, TProps>,
  ref: React.ForwardedRef<HTMLButtonElement>
) => {
  const { isKeepMounted } = useActionMenuContext();

  if (Target) {
    return <Target loading={isKeepMounted} {...props} ref={ref} />;
  }
  if (defaultTarget === 'actionIcon') {
    return (
      <ActionIconTarget loading={isKeepMounted} {...defaultTargetProps} {...props} ref={ref} />
    );
  }

  return (
    <Button
      loading={isKeepMounted}
      variant="gray"
      size="md"
      rightSection={
        <ThemeIcon variant="transparent" size="xs" c="gray">
          <IconChevronDown />
        </ThemeIcon>
      }
      {...props}
      {...defaultTargetProps}
      ref={ref}
    >
      Actions
    </Button>
  );
};

const ActionMenuTarget = forwardRef(ActionsMenuTargetInner) as <
  TDefaultTarget extends ActionMenuDefaultTarget = 'button',
>(
  props: Partial<ActionMenuContainerProps<TDefaultTarget>> & {
    ref?: React.ForwardedRef<HTMLButtonElement>;
  }
) => React.ReactElement;
ActionsMenuTargetInner.displayName = 'ActionsMenuTargetInner';

export { ActionMenuTarget };
